import { ReactNode } from 'react';
import styles from './DropdownLabel.module.css';

export type DropdownLabelProps = {
  'label'?: ReactNode;
  'tooltip'?: ReactNode;
  'data-testid'?: string;
};

export default function DropdownLabel({
  label,
  tooltip,
  'data-testid': dataTestId = 'dropdownLabel',
}: DropdownLabelProps) {
  if (!label) return null;
  return (
    <div className={styles.labelContainer} data-testid={dataTestId}>
      <label className={styles.label}>{label}</label>
      {tooltip}
    </div>
  );
}
